var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "item-row-quote-builder-labour quote-builder-item-row",
      class: [
        {
          "is-selected": _vm.isSelected,
          "is-open": _vm.isSelected && !_vm.isFullWidth,
        },
        `quote-builder-item-${_vm.$theme.name}`,
        "type-" + _vm.item.itemType,
        _vm.defaultRowColourClass(
          _vm.item,
          _vm.getItemAssessments(_vm.item),
          _vm.displayDeleted
        ),
        _vm.rowDisplayStatus(_vm.item, _vm.getItemAssessments(_vm.item)),
      ],
      attrs: { id: _vm.item.quoteItemId },
    },
    [
      _c("quote-builder-labour-item-template", {
        attrs: {
          "is-full-width": _vm.isFullWidth,
          "is-quote-hour": _vm.isQuoteTypeHour,
          "is-fully-expanded": _vm.isSelected && !_vm.isFullWidth,
          "is-selected": _vm.isSelected,
          "is-header": false,
          "is-paint-item": _vm.isPaint,
          "is-ntar": _vm.isNtar,
          "show-paint-loading": _vm.showLoading,
          "next-line-number": _vm.nextLineNumber,
        },
        on: { handleClick: _vm.handleClick },
        scopedSlots: _vm._u(
          [
            {
              key: "description",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "is-flex",
                      class: [_vm.defaultCellColourClass(_vm.item, "itemDesc")],
                      style: { width: "100%" },
                    },
                    [
                      _vm.isSelected &&
                      !_vm.item.deleteOtherItem &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      _vm.$company.setting.itemAutoCompleteEnabled
                        ? _c("item-description-autocomplete", {
                            directives: [
                              { name: "focus-next", rawName: "v-focus-next" },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                            ],
                            style: { width: "100%" },
                            attrs: {
                              "schedule-id": _vm.vehicle.scheduleId,
                              "body-id": _vm.vehicle.bodyId,
                              id: _vm.item.quoteItemId + "-itemDesc",
                              "class-prop":
                                (!_vm.isValidItemDesc(_vm.item.quoteItemId)
                                  ? "is-danger "
                                  : "") + _vm.defaultRowColourClass(_vm.item),
                              "item-type": _vm.ItemTypes.LABOUR,
                              "times-style": _vm.innerValue.labourType,
                            },
                            on: {
                              select: function ($event) {
                                return _vm.onSelectItem(_vm.item, $event)
                              },
                            },
                            model: {
                              value: _vm.item.itemDesc,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "itemDesc", $$v)
                              },
                              expression: "item.itemDesc",
                            },
                          })
                        : _vm.isSelected &&
                          !_vm.item.deleteOtherItem &&
                          !_vm.readOnlyComputed &&
                          !_vm.readOnlyView &&
                          !_vm.audanetLock &&
                          !_vm.$company.setting.itemAutoCompleteEnabled &&
                          !_vm.isItemRemoved(
                            _vm.item,
                            _vm.getItemAssessments(_vm.item)
                          )
                        ? _c("input", {
                            directives: [
                              {
                                name: "focus-inserted",
                                rawName: "v-focus-inserted",
                                value: {
                                  focus: _vm.$userInfo.scrollItemLabour,
                                },
                                expression:
                                  "{ focus: $userInfo.scrollItemLabour }",
                              },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.itemDesc,
                                expression: "item.itemDesc",
                              },
                            ],
                            staticClass: "input editable-field",
                            class: [
                              _vm.defaultRowColourClass(_vm.item),
                              !_vm.isValidItemDesc(_vm.item.quoteItemId)
                                ? "is-danger"
                                : "",
                            ],
                            attrs: {
                              id: _vm.item.quoteItemId + "-itemDesc",
                              placeholder: "Item Description",
                            },
                            domProps: { value: _vm.item.itemDesc },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "itemDesc",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c(
                            "span",
                            {
                              staticClass: "is-quote-item-field-editable pl-2",
                              class: {
                                "is-italic has-text-danger": !_vm.item.itemDesc,
                              },
                              attrs: { id: _vm.item.quoteItemId + "-itemDesc" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.item.itemDesc || "Item Description"
                                  ) +
                                  " " +
                                  _vm._s(_vm.item.blend ? "+ BLENDING" : "") +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "loading",
              fn: function () {
                return [
                  !_vm.readOnlyComputed &&
                  !_vm.readOnlyView &&
                  !_vm.audanetLock &&
                  !_vm.isItemRemoved(_vm.item, _vm.getItemAssessments(_vm.item))
                    ? _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.item.isLoadItem && _vm.showLoading,
                              expression: "!item.isLoadItem && showLoading",
                            },
                          ],
                        },
                        [
                          _vm.isSelected
                            ? _c("div", { staticClass: "select" }, [
                                _c(
                                  "select",
                                  {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.item.loadingPercent,
                                        expression: "item.loadingPercent",
                                      },
                                      {
                                        name: "focus-next",
                                        rawName: "v-focus-next",
                                      },
                                    ],
                                    class: _vm.defaultRowColourClass(
                                      _vm.item,
                                      _vm.getItemAssessments(_vm.item),
                                      false
                                    ),
                                    attrs: {
                                      id:
                                        _vm.item.quoteItemId +
                                        "-loadingPercent",
                                    },
                                    on: {
                                      change: [
                                        function ($event) {
                                          var $$selectedVal =
                                            Array.prototype.filter
                                              .call(
                                                $event.target.options,
                                                function (o) {
                                                  return o.selected
                                                }
                                              )
                                              .map(function (o) {
                                                var val =
                                                  "_value" in o
                                                    ? o._value
                                                    : o.value
                                                return val
                                              })
                                          _vm.$set(
                                            _vm.item,
                                            "loadingPercent",
                                            $event.target.multiple
                                              ? $$selectedVal
                                              : $$selectedVal[0]
                                          )
                                        },
                                        function ($event) {
                                          return _vm.changeLoadingPercent(
                                            _vm.item
                                          )
                                        },
                                      ],
                                    },
                                  },
                                  [
                                    _c("option", { domProps: { value: 0 } }, [
                                      _vm._v("0%"),
                                    ]),
                                    _c("option", { domProps: { value: 10 } }, [
                                      _vm._v("10%"),
                                    ]),
                                    _c("option", { domProps: { value: 25 } }, [
                                      _vm._v("25%"),
                                    ]),
                                  ]
                                ),
                              ])
                            : _c(
                                "span",
                                {
                                  staticClass: "is-quote-item-field-editable",
                                  attrs: {
                                    id:
                                      _vm.item.quoteItemId + "-loadingPercent",
                                  },
                                },
                                [_vm._v(_vm._s(_vm.item.loadingPercent) + "%")]
                              ),
                        ]
                      )
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            {
              key: "report",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "is-clickable",
                      class: {
                        disabled:
                          _vm.item.deleteOtherItem ||
                          !_vm.canMakeReportOnly(_vm.item),
                      },
                      on: {
                        click: ($event) => _vm.updateReport(_vm.item, $event),
                      },
                    },
                    [
                      _c("div", { staticClass: "is-flex" }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: { theme: "secondary", enabled: true },
                                expression:
                                  "{ theme: 'secondary', enabled: true }",
                              },
                            ],
                            staticClass: "tag p-1 px-2",
                            class: _vm.item.reportOnly
                              ? "is-dark is-danger "
                              : "is-white",
                            attrs: { content: "Report" },
                          },
                          [_vm._v("R ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "blend",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass: "is-clickable",
                      on: {
                        click: ($event) => _vm.updateBlend(_vm.item, $event),
                      },
                    },
                    [
                      _c("div", { staticClass: "is-flex" }, [
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "tippy",
                                rawName: "v-tippy",
                                value: { theme: "secondary", enabled: true },
                                expression:
                                  "{ theme: 'secondary', enabled: true }",
                              },
                            ],
                            staticClass: "tag is-link p-1 px-2",
                            class: _vm.item.blend ? "is-dark " : "is-light",
                            attrs: { content: "Blend" },
                          },
                          [_vm._v("B ")]
                        ),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "rates",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      class: [
                        { tooltip: _vm.isItemInvoiced(_vm.item) === true },
                      ],
                      attrs: {
                        "data-tooltip": "Item rate is already invoiced!",
                      },
                    },
                    [
                      _vm.isSelected &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      ) &&
                      !_vm.isItemInvoiced(_vm.item)
                        ? _c("vue-numeric", {
                            directives: [
                              { name: "focus-next", rawName: "v-focus-next" },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                            ],
                            staticClass:
                              "input has-text-right editable-field skip-tab",
                            class: [
                              _vm.defaultRowColourClass(
                                _vm.item,
                                _vm.getItemAssessments(_vm.item),
                                false
                              ),
                              _vm.item.rate !==
                              _vm.getLabourRateEx(_vm.item).rate
                                ? "is-warning"
                                : "",
                            ],
                            attrs: {
                              id: _vm.item.quoteItemId + "-rate",
                              placeholder: "Rate",
                              precision: 2,
                              min: 0,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.onRateChange(_vm.item)
                              },
                            },
                            model: {
                              value: _vm.item.rate,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "rate", _vm._n($$v))
                              },
                              expression: "item.rate",
                            },
                          })
                        : _c(
                            "div",
                            {
                              staticClass:
                                "is-flex is-justify-content-end is-quote-item-field-editable",
                              attrs: { id: _vm.item.quoteItemId + "-rate" },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.item.rate,
                                      _vm.$userInfo.locale,
                                      false,
                                      2
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "hour_value",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "is-flex is-justify-content-end" },
                    [
                      _vm.isSelected &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("vue-numeric", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                              {
                                name: "focus-next-element-on-arrow-directive",
                                rawName:
                                  "v-focus-next-element-on-arrow-directive:callback",
                                value: _vm.handleArrowKeys,
                                expression: "handleArrowKeys",
                                arg: "callback",
                              },
                            ],
                            staticClass: "input has-text-right editable-field",
                            class: [
                              _vm.defaultRowColourClass(
                                _vm.item,
                                _vm.getItemAssessments(_vm.item),
                                false
                              ),
                              { "is-danger": !_vm.item.hourValue },
                            ],
                            attrs: {
                              id: _vm.item.quoteItemId + "-hourValue",
                              placeholder: _vm.isQuoteHour ? "H(s)" : "$",
                              precision: 2,
                              minus: true,
                            },
                            on: {
                              input: function ($event) {
                                return _vm.updateValue(_vm.item)
                              },
                            },
                            model: {
                              value: _vm.item.hourValue,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "hourValue", $$v)
                              },
                              expression: "item.hourValue",
                            },
                          })
                        : _vm.isQuoteHour
                        ? _c(
                            "span",
                            {
                              staticClass: "is-quote-item-field-editable",
                              attrs: {
                                id: _vm.item.quoteItemId + "-hourValue",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.item.hourValue?.toFixed(2)) +
                                  " "
                              ),
                            ]
                          )
                        : _c(
                            "span",
                            {
                              staticClass: "is-quote-item-field-editable",
                              attrs: {
                                id: _vm.item.quoteItemId + "-hourValue",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$filters.formatCurrency(
                                      _vm.item.hourValue,
                                      _vm.$userInfo.locale,
                                      false,
                                      2
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "total_value",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      staticClass:
                        "is-flex is-justify-content-end is-align-items-center",
                      class: { "has-text-danger": !_vm.item.dollarValue },
                    },
                    [
                      _c("span", [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$filters.formatCurrency(
                                _vm.item.dollarValue,
                                _vm.$userInfo.locale,
                                false,
                                2
                              )
                            ) +
                            " "
                        ),
                      ]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "present_as",
              fn: function () {
                return [
                  _c("present-as-component", {
                    attrs: { item: _vm.item },
                    on: {
                      handlePresentAs: function ($event) {
                        !_vm.readOnlyComputed &&
                          _vm.$emit("handlePresentAs", _vm.item)
                      },
                    },
                  }),
                ]
              },
              proxy: true,
            },
            _vm.item.itemComment
              ? {
                  key: "comment",
                  fn: function () {
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "tippy",
                              rawName: "v-tippy",
                              value: {
                                theme: "secondary",
                                enabled: true,
                                content: _vm.item.itemComment,
                              },
                              expression:
                                "{ theme: 'secondary', enabled: true, content:item.itemComment }",
                            },
                          ],
                        },
                        [
                          _c("span", {
                            staticClass:
                              "mdi has-text-primary is-primary mdi-18px mdi-message-reply-text mr-1 is-clickable",
                          }),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "assessment_status",
              fn: function () {
                return [
                  (_vm.innerValue.quoteAssessments?.length || 0) > 0
                    ? _c("supplementary-icon", {
                        staticClass: "icon",
                        attrs: {
                          item: _vm.item,
                          "item-assessments": _vm.getItemAssessments(_vm.item),
                          "next-assessment-number": _vm.nextSupplemetryNo,
                          "quoting-method": _vm.innerValue.quotingMethod,
                          "icon-size": 4,
                        },
                      })
                    : _vm._e(),
                ]
              },
              proxy: true,
            },
            !_vm.audanetLock &&
            !_vm.isItemRemoved(_vm.item, _vm.getItemAssessments(_vm.item)) &&
            (_vm.item.isDeleted === false || _vm.item.deleted === false)
              ? {
                  key: "delete",
                  fn: function () {
                    return [
                      _c(
                        "button",
                        {
                          staticClass:
                            "button is-ghost is-small tooltip p-0 mx-1 has-text-grey-lighter",
                          attrs: {
                            "data-tooltip": "Delete",
                            disabled: _vm.readOnlyComputed,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.$emit("deleteItem", _vm.item)
                            },
                          },
                        },
                        [
                          _c(
                            "span",
                            {
                              staticClass: "material-symbols-rounded",
                              class: { "is-clickable": !_vm.readOnlyComputed },
                              on: {
                                mouseenter: function ($event) {
                                  return $event.target.classList.add(
                                    "has-text-danger"
                                  )
                                },
                                mouseleave: function ($event) {
                                  return $event.target.classList.remove(
                                    "has-text-danger"
                                  )
                                },
                              },
                            },
                            [_vm._v(" delete ")]
                          ),
                        ]
                      ),
                    ]
                  },
                  proxy: true,
                }
              : null,
            {
              key: "draggable",
              fn: function () {
                return [
                  _c(
                    "button",
                    {
                      staticClass:
                        "button is-ghost is-small tooltip item-drag-handle px-0",
                      staticStyle: { height: "26px" },
                      attrs: {
                        "data-tooltip": "Drag",
                        disabled: _vm.readOnlyComputed || _vm.readOnlyView,
                      },
                    },
                    [
                      _c("span", {
                        staticClass:
                          "mdi mdi-drag-vertical mdi-24px has-text-grey-light",
                        class: { "is-clickable": !_vm.readOnlyComputed },
                      }),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "lineNo",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "secondary",
                            enabled: true,
                            content: "Line Number",
                          },
                          expression:
                            "{ theme: 'secondary', enabled: true, content: 'Line Number' }",
                        },
                      ],
                    },
                    [
                      !_vm.readOnlyComputed &&
                      _vm.$userInfo.isSupportUser &&
                      !_vm.readOnlyView &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("vue-numeric", {
                            directives: [
                              { name: "focus-next", rawName: "v-focus-next" },
                            ],
                            staticClass: "input has-text-right",
                            class: _vm.defaultRowColourClass(
                              _vm.item,
                              _vm.getItemAssessments(_vm.item),
                              false
                            ),
                            attrs: { precision: 0, separator: "" },
                            model: {
                              value: _vm.item.lineNumber,
                              callback: function ($$v) {
                                _vm.$set(_vm.item, "lineNumber", _vm._n($$v))
                              },
                              expression: "item.lineNumber",
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.item.lineNumber))]),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "itemNo",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "secondary",
                            enabled: true,
                            content: "Item Number",
                          },
                          expression:
                            "{ theme: 'secondary', enabled: true, content: 'Item Number' }",
                        },
                      ],
                    },
                    [
                      !_vm.item.deleteOtherItem &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("input", {
                            directives: [
                              { name: "focus-next", rawName: "v-focus-next" },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.itemNo,
                                expression: "item.itemNo",
                              },
                            ],
                            staticClass: "input",
                            class: [
                              _vm.defaultRowColourClass(
                                _vm.item,
                                _vm.getItemAssessments(_vm.item),
                                false
                              ),
                              !_vm.isValidItemNo(_vm.item.quoteItemId)
                                ? "is-danger"
                                : "",
                            ],
                            attrs: {
                              placeholder: "Item No.",
                              id: _vm.item.quoteItemId + "-itemNo",
                            },
                            domProps: { value: _vm.item.itemNo },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "itemNo",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.item.itemNo))]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            {
              key: "itemStatus",
              fn: function () {
                return [
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            theme: "secondary",
                            enabled: true,
                            content: "Item Status",
                          },
                          expression:
                            "{ theme: 'secondary', enabled: true, content: 'Item Status' }",
                        },
                      ],
                    },
                    [
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("input", {
                            directives: [
                              {
                                name: "focus-next",
                                rawName: "v-focus-next:callback",
                                value: _vm.handleTransitionNextRow,
                                expression: "handleTransitionNextRow",
                                arg: "callback",
                              },
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.item.itemStatus,
                                expression: "item.itemStatus",
                              },
                            ],
                            staticClass: "input is-capitalized",
                            domProps: { value: _vm.item.itemStatus },
                            on: {
                              input: function ($event) {
                                if ($event.target.composing) return
                                _vm.$set(
                                  _vm.item,
                                  "itemStatus",
                                  $event.target.value
                                )
                              },
                            },
                          })
                        : _c("span", [_vm._v(_vm._s(_vm.item.itemStatus))]),
                    ]
                  ),
                ]
              },
              proxy: true,
            },
            _vm.isPaint
              ? {
                  key: "paint_group",
                  fn: function () {
                    return [
                      _vm.isSelected &&
                      _vm.vehicle &&
                      !_vm.item.deleteOtherItem &&
                      !_vm.readOnlyComputed &&
                      !_vm.readOnlyView &&
                      !_vm.audanetLock &&
                      !_vm.isItemRemoved(
                        _vm.item,
                        _vm.getItemAssessments(_vm.item)
                      )
                        ? _c("div", { staticClass: "select" }, [
                            _c(
                              "select",
                              {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: _vm.item.opgCode,
                                    expression: "item.opgCode",
                                  },
                                  {
                                    name: "focus-next",
                                    rawName: "v-focus-next:callback",
                                    value: _vm.handleTransitionNextRow,
                                    expression: "handleTransitionNextRow",
                                    arg: "callback",
                                  },
                                ],
                                class: _vm.defaultRowColourClass(
                                  _vm.item,
                                  _vm.getItemAssessments(_vm.item),
                                  false
                                ),
                                on: {
                                  change: [
                                    function ($event) {
                                      var $$selectedVal = Array.prototype.filter
                                        .call(
                                          $event.target.options,
                                          function (o) {
                                            return o.selected
                                          }
                                        )
                                        .map(function (o) {
                                          var val =
                                            "_value" in o ? o._value : o.value
                                          return val
                                        })
                                      _vm.$set(
                                        _vm.item,
                                        "opgCode",
                                        $event.target.multiple
                                          ? $$selectedVal
                                          : $$selectedVal[0]
                                      )
                                    },
                                    function ($event) {
                                      return _vm.handlePaintOpgChange(_vm.item)
                                    },
                                  ],
                                },
                              },
                              _vm._l(
                                _vm.paintGroupTypes,
                                function (paintGroup) {
                                  return _c(
                                    "option",
                                    {
                                      key: paintGroup,
                                      class: {
                                        "has-text-success":
                                          paintGroup === _vm.vehicle.paintGroup,
                                      },
                                      domProps: { value: paintGroup },
                                    },
                                    [_vm._v(_vm._s(paintGroup))]
                                  )
                                }
                              ),
                              0
                            ),
                          ])
                        : _c("span", [
                            _vm._v(_vm._s(_vm.item.opgCode || "--")),
                          ]),
                    ]
                  },
                  proxy: true,
                }
              : null,
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }